import React, { useEffect } from 'react';

interface AwardBadgeProps {
    year?: number;
    restaurantName?: string;
    awardTitle?: string;
    link?: string;
}

const AwardBadge: React.FC<AwardBadgeProps> = ({
                                                   year = 2026,
                                                   restaurantName = 'Mon Tresor',
                                                   awardTitle = 'Лучший интерьер',
                                                   link = 'https://ru.restaurantguru.com/Mon-Tresor-Yoshkar-Ola',
                                               }) => {
    // Простая валидация без Yup
    useEffect(() => {
        if (year < 2020 || year > 2030) {
            console.warn('Year should be between 2020 and 2030');
        }
        if (!restaurantName || restaurantName.length < 2) {
            console.warn('Restaurant name is too short');
        }
        if (!link || !link.startsWith('http')) {
            console.warn('Invalid link');
        }
    }, [year, restaurantName, link]);

    const handleCircleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        const target = event.target as HTMLElement;
        if (target.nodeName.toLowerCase() !== 'a') {
            const linkElement = event.currentTarget.querySelector('.circle_bw_link') as HTMLAnchorElement;
            if (linkElement?.href) {
                window.open(linkElement.href);
            }
        }
    };

    return (
        <>
            <link href="https://awards.infcdn.net/2024/circle_v3.css" rel="stylesheet" />

            <div
                id="circle_bw"
                data-length="33"
                className="circle_bw_black rg-award-lang-ru_RU"
                onClick={handleCircleClick}
            >
                <p className="circle_bw_year">{year}</p>

                <div className="circle_bw_name">
                    <a className="circle_bw_link" target="_blank" href={link}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="178px"
                            height="178px"
                            viewBox="0 0 178 178"
                        >
                            <defs>
                                <path id="circle_bw_name-arc" d="M 12 89 a 77 77 0 0 0 154 0" />
                            </defs>
                            <text className="circle_bw_name_txt f12" fill="#000" textAnchor="middle">
                                <textPath startOffset="50%" xlinkHref="#circle_bw_name-arc">
                                    {restaurantName}
                                </textPath>
                            </text>
                        </svg>
                    </a>
                </div>

                <div className="circle_bw_nom">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        width="200px"
                        height="200px"
                        viewBox="0 0 200 200"
                    >
                        <defs>
                            <path id="circle_bw_nom-arc1" d="M 30 100 a 70 70 0 1 1 140 0" />
                        </defs>
                        <text className="circle_bw_nom_txt f12" fill="#000" textAnchor="middle">
                            <textPath startOffset="50%" xlinkHref="#circle_bw_nom-arc1">
                                {awardTitle}
                            </textPath>
                        </text>
                    </svg>
                </div>

                <a
                    className="circle_bw_home"
                    style={{ fontSize: 0 }}
                    href="https://restaurantguru.com"
                    target="_blank"
                >
                    Restaurant Guru
                </a>
            </div>
        </>
    );
};

export default AwardBadge;